import SvgIcon from '@/pages/home/components/SvgIcon';
import React, { useCallback, useMemo } from 'react';
import { Progress, Rate } from 'tea-component';
import { getPercentageValue, getShowCount } from '@/pages/opinion/utils';
import { useHistory, useIntl } from 'umi';
import './index.scss';
import NoDataCommon from '../NoDataCommon';
import moment from 'moment';
import { ratingColors } from '../../constants';
import StarBubble from '../StarBubble';
import BubbleCommon from '../BubbleCommon';
import { goStatsDetailAction } from '../../pages/stats/Detail';
import { getStarIcon } from '@op/utils/text';

const LineContextCard = ({
  data,
  ratingInfo,
  filter,
  channel,
  hasTitle = true,
}: any) => {
  const renderTitleTime = (time: string) => {
    return time
      ? moment(time).format('YYYY-MM-DD HH:mm:ss')
      : moment(data.time).format('YYYY-MM-DD');
  };

  const { formatMessage } = useIntl();
  const { detail, time, mentions, score, ratingType } = useMemo(() => {
    const key = data.ratingKey;
    const { detail, latest_time, mentions, score } = ratingInfo?.[key] || {};

    return {
      detail: detail || [],
      mentions: mentions || 0,
      score: score || 0,
      ratingType: key,
      time: key === 'selected' ? data.time : renderTitleTime(latest_time),
    };
  }, [ratingInfo, data, renderTitleTime]);

  const countPrecent = useCallback(
    (value: number) => {
      return getPercentageValue(value || 0, mentions, 4) * 100;
    },
    [mentions],
  );
  const history = useHistory();
  const ratings = useMemo(() => {
    return [...ratingColors].reverse();
  }, []);

  const getRateScore = (score: number) => {
    if (channel === 'taptap' && ratingType === 'lifetime') {
      return score / 2;
    }

    return score;
  };

  return (
    <div className="dbo-star-context">
      {hasTitle && (
        <div className="components-title">
          <div className="left-title">{data.title}</div>
          <div className="right-time">
            <BubbleCommon tipsMap={data.context}>({time})</BubbleCommon>
          </div>
        </div>
      )}

      {parseInt(score, 10) === 0 ? (
        <NoDataCommon hasDesc style={{ height: 90 }}></NoDataCommon>
      ) : (
        <StarBubble
          isLifetime={ratingType === 'lifetime'}
          detail={detail}
          mentions={mentions}
        >
          <div className="dbo-star-components">
            <div className="components-left">
              <div className="left-context">
                <div className="left-context-left">
                  <div className="text-num">{score?.toFixed(1)}</div>
                  <div className="star-flex">
                    <Rate
                      allowHalf
                      readonly
                      theme="primary"
                      className="scores-rate"
                      value={getRateScore(score)}
                    />
                  </div>
                  <div className="text-review">
                    {getShowCount(mentions)}{' '}
                    {formatMessage({
                      id: ratingType === 'lifetime' ? 'Ratings-1' : 'Reviews-1',
                    })}
                  </div>
                </div>
                <div className="left-context-right">
                  {[5, 4, 3, 2, 1].map((item) => (
                    <div key={item} className="starNum-flex">
                      {getStarIcon(item)}
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className="components-right">
              <div className="right-progress">
                {ratings.map((color, index) => (
                  <Progress
                    key={color}
                    strokeColor={color}
                    percent={countPrecent(detail?.[5 - index])}
                    strokeWidth={8}
                    onClick={() => {
                      goStatsDetailAction({
                        path: `/opinion/Feeds/Feeds?tab=gameStore`,
                        params: {
                          statsDetailType: 'feeds-gameStoreLine',
                          ...filter,
                          channel: [channel],
                          channel_type: 'comments',
                          reviews_rating: ['' + (5 - index)],
                        },
                        history,
                      });
                    }}
                  />
                ))}
              </div>
            </div>
          </div>
        </StarBubble>
      )}
    </div>
  );
};
export default LineContextCard;
